import { render } from "./ResultDialogTemplate.vue?vue&type=template&id=5aa14f77&ts=true"
import script from "./ResultDialogTemplate.vue?vue&type=script&lang=ts"
export * from "./ResultDialogTemplate.vue?vue&type=script&lang=ts"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__